import { render } from "./SocLinks.vue?vue&type=template&id=544a6e9f"
import script from "./SocLinks.vue?vue&type=script&lang=js"
export * from "./SocLinks.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__